import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@mui/material'

type CustomButtonProps = {
  title: string
  btnVariant?: 'contained' | 'outlined' | 'text'
  disabled?: boolean
  btnStyle?: Record<string, unknown>
  onClick: () => void
  iconName?: string
  style?: any
  id?: string
  size?: any
  dataTestId?: string
}

const CustomButton = ({
  title,
  btnVariant,
  disabled,
  btnStyle,
  onClick,
  iconName,
  style,
  id,
  size,
  dataTestId,
}: CustomButtonProps) => {
  const { t } = useTranslation()
  const icon = () =>
    iconName ? (
      <Icon className={`${btnVariant ? `material-icons-${btnVariant}` : ''}`}>
        {iconName}
      </Icon>
    ) : null

  return (
    <Button
      variant={btnVariant}
      disabled={disabled}
      onClick={onClick}
      sx={btnStyle}
      data-testid={dataTestId || 'customButton'}
      startIcon={icon()}
      style={style}
      id={id}
      size={size}
    >
      {t(title)}
    </Button>
  )
}

export default CustomButton
